window.Cell = function () {
    var el = this;
    var isMoving = false;
    var isResizing = false;
    var isRotating = false;
    var elsList = {};

    el.lastBorderAttributes = {};

    var alignmentsOx = {};
    var alignmentsOy = {};
    el.alignments = [];

    el.cutArea = {x: 0, y: 0, width: 0, height: 0};

    function initAlignments() {
        var i;
        var cells = el.workData.workareas[el.selectWorkareaId].cells;
        alignmentsOx = {};
        alignmentsOy = {};

        for (i in cells) {
            if (i !== el.selectId && cells[i] !== null) {
                alignmentsOx[cells[i].border_x] = true;
                alignmentsOx[parseInt(cells[i].border_x) + parseInt(cells[i].border_width)] = true;
                alignmentsOy[cells[i].border_y] = true;
                alignmentsOy[parseInt(cells[i].border_y) + parseInt(cells[i].border_height)] = true;
            }
        }
    }

    function checkAlignments(pos) {
        el.alignments = [];

        if (alignmentsOx.hasOwnProperty(pos.x)) {
            el.alignments.x = {
                x1: pos.x,
                y1: 0,
                x2: pos.x,
                y2: '100%'
            };
        }

        if (alignmentsOx.hasOwnProperty(pos.x + pos.width)) {
            el.alignments.width = {
                x1: pos.x + pos.width,
                y1: 0,
                x2: pos.x + pos.width,
                y2: '100%'
            };
        }

        if (alignmentsOy.hasOwnProperty(pos.y)) {
            el.alignments.y = {
                x1: 0,
                y1: pos.y,
                x2: '100%',
                y2: pos.y
            };
        }

        if (alignmentsOy.hasOwnProperty(pos.y + pos.height)) {
            el.alignments.height = {
                x1: 0,
                y1: pos.y + pos.height,
                x2: '100%',
                y2: pos.y + pos.height
            };
        }
    }

    function hideAlignments() {
        if (el.selectType === 'cell') {
            $("#alignment-x").attr('stroke-width', 0);
            $("#alignment-width").attr('stroke-width', 0);
            $("#alignment-y").attr('stroke-width', 0);
            $("#alignment-height").attr('stroke-width', 0);
        }
    }

    el.add = function () {
        var keys = Object.keys(el.workData.workareas[el.selectWorkareaId].cells);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var cell = {
            border_width: 164,
            border_height: 124,
            border_x: 98,
            border_y: 98,
            border_color: '#ffffff',
            border_shadow: 2,
            border_opacity: 1,
            width: 160,
            height: 120,
            x: 100,
            y: 100
        };

        if (Object.keys(el.lastBorderAttributes).length > 0) {
            cell = el.borderCell.updateData(el.lastBorderAttributes, cell);
        }

        var image = el.workData.workareas[el.selectWorkareaId].images[number];
        if (image !== null && image !== undefined) {
            var pos = {
                x: cell.x,
                y: cell.y,
                width: cell.width,
                height: cell.height
            };
            pos = el.upImages.setImagePosition(image.data_width, image.data_height, pos);
            image.x = pos.x;
            image.y = pos.y;
            image.width = pos.width;
            image.height = pos.height;
        }

        el._parent.workData.workareas[el.selectWorkareaId].cells[number] = cell;

        el.layer.add(el.selectWorkareaId, 'cells', number);

        el.workarea.render();

        el.history.add();
    };

    el.addWithImage = function() {
        el.add();
        var keys = Object.keys(el.workData.workareas[el.selectWorkareaId].cells);
        var number = parseInt(keys[keys.length - 1]);

        el.upImages.drop('images', el.selectWorkareaId, number);
    };

    el.remove = function () {
        var reversal = el.workData.workareas[el.selectWorkareaId];
        var element = el.svgRoot.getElementById('grid-cell-' + el.selectWorkareaId + '-' + el.selectId);
        element.parentNode.removeChild(element);

        if (reversal.images.hasOwnProperty(el.selectId)) {
            el.upImages.unsetUsedImage(reversal.images[el.selectId].name);
            delete reversal.images[el.selectId];
        }

        delete reversal.cells[el.selectId];
        el.layer.remove(el.selectWorkareaId, 'cells', el.selectId);

        el.selection.hide();
        el.history.add();
    };

    el.beginMove = function () {
        isMoving = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        elsList = {
            elements: [],
            coords: [],
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0,
            parent: false
        };

        var elementsList = [
            'border-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-clippath-rect-' + el.selectWorkareaId + '-' + el.selectId,
            'images-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-bg-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-image-add-btn-' + el.selectWorkareaId + '-' + el.selectId,
            'mask-image-' + el.selectWorkareaId + '-' + el.selectId,
            'border-image-' + el.selectWorkareaId + '-' + el.selectId
        ];

        var i, element;
        for (i = 0; i < elementsList.length; i++) {
            element = el.svgRoot.getElementById(elementsList[i]);
            if (element) {
                elsList.elements.push(element);
                elsList.coords.push(el.transform.getPosition(element));

                if (element.getAttribute('class') === 'border') {
                    element.removeAttribute('filter');
                }
            }
        }

        elsList.parent = elsList.elements[0].parentNode;

        initAlignments();
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;

            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }
            
            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var reversal = el._parent.workData.workareas[el.selectWorkareaId];
            var elements = elsList.elements;
            var parent = elsList.parent;

            var parentTransform = el.transform.deleteRotate(parent);

            var i, elsPos = {};
            for (i = 0; i < elements.length; i++) {
                elsPos[i] = {
                    x: parseInt(elsList.coords[i].x + elsList.x),
                    y: parseInt(elsList.coords[i].y + elsList.y),
                    width: elsList.coords[i].width,
                    height: elsList.coords[i].height
                };
                
                el.transform.setPosition(elements[i], elsPos[i].x, elsPos[i].y);
            }

            // set rotate of element
            if (parentTransform.angle !== 0) {
                el.transform.setRotate(parent, parentTransform.angle);
            }

            checkAlignments(elsPos[0]);

            // set new position for el.workData
            reversal.cells[el.selectId].x = elsPos[1].x;
            reversal.cells[el.selectId].y = elsPos[1].y;
            reversal.cells[el.selectId].border_x = elsPos[0].x;
            reversal.cells[el.selectId].border_y = elsPos[0].y;

            var rotate = el.transform.getRotate(parent);
            reversal.cells[el.selectId].rotate_angle = rotate.angle;
            reversal.cells[el.selectId].rotate_x = rotate.x;
            reversal.cells[el.selectId].rotate_y = rotate.y;

            // detect transform for image
            if (reversal.images.hasOwnProperty(el.selectId)) {
                reversal.images[el.selectId].x = elsPos[2].x;
                reversal.images[el.selectId].y = elsPos[2].y;

                var rotate = el.transform.getRotate(elements[2]);
                reversal.images[el.selectId].rotate_angle = rotate.angle;
                reversal.images[el.selectId].rotate_x = rotate.x;
                reversal.images[el.selectId].rotate_y = rotate.y;
            }

            el.selection.update(elements[0]);
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.elements[0].setAttribute('filter', urlFilter);
            //hideAlignments();
            el.history.add();
        }
    };

    function updateResizingData(coords) {
        var cell = el._parent.workData.workareas[el.selectWorkareaId].cells[el.selectId];
        var items = elsList.elements || [];

        // update position for viewer
        for (var i = 0; i < items.length; i++) {
            items[i].setAttribute('x', coords[i].x);
            items[i].setAttribute('y', coords[i].y);
            items[i].setAttribute('width', coords[i].width);
            items[i].setAttribute('height', coords[i].height);
        }

        // update image position
        var images = el._parent.workData.workareas[el.selectWorkareaId].images;
        if (images.hasOwnProperty(el.selectId)) {
            var image = images[el.selectId];
            var imageElement = el.svgRoot.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

            el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);

            imageElement.setAttribute('x', image.x);
            imageElement.setAttribute('y', image.y);
            imageElement.setAttribute('width', image.width);
            imageElement.setAttribute('height', image.height);

            var rotate = el.transform.getRotate(imageElement);
            el.transform.setRotate(imageElement, rotate.angle);
            image.rotate_angle = rotate.angle;
            image.rotate_x = rotate.x;
            image.rotate_y = rotate.y;
        }

        checkAlignments(coords[0]);

        // update position for el.workData
        cell.border_x = coords[0].x;
        cell.border_y = coords[0].y;
        cell.border_width = coords[0].width;
        cell.border_height = coords[0].height;
        cell.x = coords[1].x;
        cell.y = coords[1].y;
        cell.width = coords[1].width;
        cell.height = coords[1].height;

        el.selection.update(items[0]);
    }

    el.beginResize = function (type) {
        isResizing = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        elsList = {
            elements: [],
            coords: [],
            lastX: 0,
            lastY: 0,
            type: type,
            x: 0,
            y: 0
        };

        var elementsList = [
            'border-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-clippath-rect-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-bg-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-image-add-btn-' + el.selectWorkareaId + '-' + el.selectId,
            'mask-image-' + el.selectWorkareaId + '-' + el.selectId,
            'border-image-' + el.selectWorkareaId + '-' + el.selectId
        ];

        var i, element;
        for (i = 0; i < elementsList.length; i++) {
            element = el.svgRoot.getElementById(elementsList[i]);
            if (element) {
                elsList.elements.push(element);
                elsList.coords.push(el.transform.getPosition(element));

                if (element.getAttribute('class') === 'border') {
                    element.removeAttribute('filter');
                }
            }
        }

        elsList.parent = elsList.elements[0].parentNode;

        initAlignments();
    };

    el.resize = function (event) {
        if (isResizing) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var items = elsList.elements || [];
            var coords = [];
            var minSize = 100;
            
            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var i;
            for (i = 0; i < items.length; i++) {
                coords[i] = $.extend(true, {}, elsList.coords[i]);

                switch (elsList.type) {
                    case 'width':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        break;
                    case 'height':
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                    case 'x':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        break;
                    case 'y':
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'nw':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'ne':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'se':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                    case 'sw':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                }
            }

            // check size cell
            if (
                    coords[0].width < minSize
                    || coords[0].height < minSize
                    //   || coords[0].width > el.workData.width
                    //   || coords[0].height > el.workData.height
                    ) {
                return false;
            }

            updateResizingData(coords);
        }
    };

    el.endResize = function () {
        if (isResizing) {
            isResizing = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.elements[0].setAttribute('filter', urlFilter);
            hideAlignments();
            el.history.add();
        }
    };

    el.beginRotate = function () {
        isRotating = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        var element = el.svgRoot.getElementById('border-item-' + el.selectWorkareaId + '-' + el.selectId);
        var pos = el.transform.getPosition(element);

        elsList = {
            element: element.parentNode,
            child: element,
            coords: {
                centerX: pos.x + (pos.width / 2),
                centerY: pos.y + (pos.height / 2)
            }
        };

        element.removeAttribute('filter');
    };

    el.rotate = function (event) {
        if (isRotating) {
            var element = elsList.element;
            var pos = elsList.coords;

            var workAreaScale = el.workarea.workAreaScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle);

            // set new transform property for el.workData;
            var reversal = el._parent.workData.workareas[el.selectWorkareaId];
            var rotate = el.transform.getRotate(element);
            reversal.cells[el.selectId].rotate_angle = rotate.angle;
            reversal.cells[el.selectId].rotate_x = rotate.x;
            reversal.cells[el.selectId].rotate_y = rotate.y;

            el.selection.update(elsList.child);
        }
    };

    el.endRotate = function () {
        if (isRotating) {
            isRotating = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.child.setAttribute('filter', urlFilter);
            el.history.add();
        }
    };

    $('.js-cell-add').on('click', function () {
        el.add();
    });
};